// extracted by mini-css-extract-plugin
export default {"button":"aeEV6d","title":"wPdTRA","addToWalletTitle":"mH_qx8","spinnerContainer":"vKoKBc","downloadButton":"SKYn2B"};